import {
    Component,
    OnDestroy,
    AfterViewInit,
    EventEmitter,
    Input,
    Output
} from '@angular/core';

declare let tinymce: any;

@Component({
    selector: 'app-tiny-editor',
    templateUrl: './tiny-editor.component.html',
    styleUrls: ['./tiny-editor.component.scss']
})
export class TinyEditorComponent implements AfterViewInit, OnDestroy {

    @Input() elementId: String;

    @Output() onEditorKeyup = new EventEmitter<any>();
    @Output() editor_loaded = new EventEmitter<any>();

    editor;
    files;

    file_picker_callback(cb, value, meta) {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');

        // Note: In modern browsers input[type="file"] is functional without
        // even adding it to the DOM, but that might not be the case in some older
        // or quirky browsers like IE, so you might want to add it to the DOM
        // just in case, and visually hide it. And do not forget do remove it
        // once you do not need it anymore.

        input.onchange = function() {
            const file = this['files'][0];

            const reader = new FileReader();
            reader.onload = function () {
                // Note: Now we need to register the blob in TinyMCEs image blob
                // registry. In the next release this part hopefully won't be
                // necessary, as we are looking to handle it internally.
                const id = 'blobid' + (new Date()).getTime();
                const blobCache =  tinymce.activeEditor.editorUpload.blobCache;
                const base64 = reader.result.split(',')[1];
                const blobInfo = blobCache.create(id, file, base64);
                blobCache.add(blobInfo);

                // call the callback and populate the Title field with the file name
                cb(blobInfo.blobUri(), { title: file.name });
            };
            reader.readAsDataURL(file);
        };
        input.click();
    }

    ngAfterViewInit() {
        tinymce.init({
            selector: '#' + this.elementId,
            menubar: false,
            height: "250",
            paste_data_images: true,
            automatic_uploads: true,
            file_picker_types: 'image',
            file_picker_callback: this.file_picker_callback,
            default_link_target: "_blank",
            target_list: false,
            plugins: ['link', 'paste', 'table', 'textcolor', 'link', 'image'],
            skin_url: '/assets/tinymce/skins/lightgray',
            theme_url: '/assets/tinymce/themes/modern/theme.min.js',
            toolbar: [
                "formatselect fontselect fontsizeselect | bold italic underline |alignleft aligncenter alignright alignjustify | outdent indent | forecolor backcolor | table link image"
            ],

            table_default_styles: {
                width: '100%',
            },
            table_class_list: [
                {title: 'Border Table', value: 'border-table'},
            ],
            table_default_attributes: {
                class: 'border-table'
            },
            setup: editor => {
                this.editor = editor;
                editor.on('keyup', () => {
                    const content = editor.getContent();
                    this.onEditorKeyup.emit(content);
                });
                editor.on('init', (e) => {
                    this.editor_loaded.emit(true);
                });
            },
        });
    }

    ngOnDestroy() {
        if (tinymce !== null) {
            tinymce.remove(this.editor);
            this.editor_loaded.emit(false);
        }
    }
}
